import { Autocomplete, IconButton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FIELD_TYPES } from '../../../utility/constants'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { listDataService } from '../../../services/listDataService'
import { OPERATIONS } from './ConditionalEnableDisableUI'
import DeleteIcon from '@mui/icons-material/Delete'

const ConditionalEnableDisableItemEditUI = ({
  fields,
  constraintItem,
  updateConstraint = (updated) => {},
  onDelete,
  selectedField,
}) => {
  const { user } = useAuthContext()

  const [listItems, setListItems] = useState([])

  useEffect(() => {
    ;(async () => {
      if (
        selectedField?.data_structure == FIELD_TYPES.LIST ||
        selectedField?.data_structure == FIELD_TYPES.LIST_MULTI
      ) {
        const listItemsData = await listDataService.getData(user, selectedField?.list_id)
        setListItems(listItemsData.data)
      }
    })()
  }, [selectedField])

  const getSelectedItem = (value, selectedField) => {
    if (
      selectedField?.data_structure == FIELD_TYPES.LIST ||
      selectedField?.data_structure == FIELD_TYPES.LIST_MULTI
    ) {
      const item = listItems?.find((it) => it.id == value)
      if (value && item) {
        return { value: item, label: item.value }
      } else {
        return null
      }
    }
  }

  const getSelectedField = (fieldId) => {
    const field = fields?.find((it) => it.id == fieldId)
    if (field) {
      return { value: field, label: field?.field_template_name }
    } else {
      return null
    }
  }

  return (
    <div style={{ display: 'flex', columnGap: 8, marginTop: 12, alignItems: 'center' }}>
      <Autocomplete
        value={getSelectedField(constraintItem.source_field_template_id)}
        id="autocomplete-field"
        options={fields.map((it) => {
          return { value: it, label: it.field_template_name }
        })}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Source Field" />}
        onChange={(e, v) => {
          updateConstraint({
            ...constraintItem,
            source_field_template_id: v?.value?.id || null,
          })
        }}
        size="small"
      />

      <Autocomplete
        value={
          constraintItem?.operation
            ? { value: constraintItem?.operation, label: constraintItem?.operation }
            : null
        }
        id="autocomplete-operator"
        options={Object.entries(OPERATIONS).map(([key, value]) => {
          return { value, label: key }
        })}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Operator" />}
        onChange={(e, v) => {
          updateConstraint({
            ...constraintItem,
            operation: v?.value || null,
          })
        }}
        size="small"
      />

      {selectedField?.data_structure == FIELD_TYPES.LIST ||
      selectedField?.data_structure == FIELD_TYPES.LIST_MULTI ? (
        <Autocomplete
          id="autocomplete-list-data"
          value={getSelectedItem(constraintItem.enable_on_value, selectedField)}
          options={listItems.map((item) => {
            return { value: item, label: item.value }
          })}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Enable Value" />}
          onChange={(e, v) => {
            updateConstraint({
              ...constraintItem,
              enable_on_value: v?.value?.id || null,
            })
          }}
          size="small"
        />
      ) : (
        <TextField
          value={constraintItem.enable_on_value}
          id="outlined-basic"
          label="Enable Value"
          variant="outlined"
          onChange={(e) =>
            updateConstraint({
              ...constraintItem,
              enable_on_value: e.target.value || null,
            })
          }
          size="small"
        />
      )}
      <IconButton onClick={() => onDelete(constraintItem.id)}>
        <DeleteIcon size="small" />
      </IconButton>
    </div>
  )
}

export default ConditionalEnableDisableItemEditUI
